import React from "react";
import { Box, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ImageMetadata } from "../types";

interface TemperatureFocusChartProps {
  imagesForView: ImageMetadata[];
}

const TemperatureFocusChart: React.FC<TemperatureFocusChartProps> = ({
  imagesForView,
}) => {
  // Only use light frames
  const lightFrames = imagesForView.filter((img) =>
    img.FrameType ? img.FrameType === "LIGHT" : !!img.FilterName
  );

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        p: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        minHeight: 400,
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
      >
        Temperature & Focus
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Relationship between temperature and focus position
      </Typography>
      {lightFrames.length === 0 ? (
        <Typography color="text.secondary">No data available.</Typography>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <LineChart
            data={lightFrames.map((img, i) => ({
              frame: i + 1,
              focuser: img.FocuserPosition,
              temp: img.FocuserTemp,
            }))}
          >
            <XAxis
              dataKey="frame"
              stroke="#a0a0a0"
              tick={{ fill: "#a0a0a0" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
            />
            <YAxis
              yAxisId="left"
              stroke="#4fc3f7"
              tick={{ fill: "#4fc3f7" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
              domain={[0, "auto"]}
              label={{
                value: "Focuser Position",
                angle: -90,
                position: "insideLeft",
                fill: "#4fc3f7",
              }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              stroke="#ff8a65"
              tick={{ fill: "#ff8a65" }}
              tickLine={false}
              axisLine={{ stroke: "#333" }}
              domain={[0, "auto"]}
              label={{
                value: "Temperature (°C)",
                angle: 90,
                position: "insideRight",
                fill: "#ff8a65",
              }}
            />
            <Tooltip
              contentStyle={{
                background: "#222",
                border: "1px solid #444",
                color: "#fff",
              }}
              labelStyle={{ color: "#fff" }}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="focuser"
              stroke="#4fc3f7"
              strokeWidth={2}
              dot={false}
              name="Focuser Position"
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="temp"
              stroke="#ff8a65"
              strokeWidth={2}
              dot={false}
              name="Temperature (°C)"
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Box>
  );
};

export default TemperatureFocusChart;
